import { createAction } from "@reduxjs/toolkit"

export const checkboxUpdate = createAction("CHECKBOX_UPDATE")
export const scoreReset = createAction("SCORE_RESET")
